import { CryptoStorage } from "@webcrypto/storage"

const encodeToSHA256 = async (id) => {
  const textAsBuffer = new TextEncoder().encode(id)
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const digest = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")
  return digest
}

const startSafeStorage = async (id) => {
  const digest = await encodeToSHA256(`${id}`)
  return digest ? new CryptoStorage(digest) : {}
}

export default startSafeStorage
